// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"14d4a37f","746":"b8c7094f"}[chunkId] + ".chunk.js";
};